import React from "react";
import PropTypes from "prop-types";
import "./InTransitVisibilityTable.css";

const BUCKETS = ["Delayed", "Today", "Tomorrow", "Day After Tomorrow"];

/* ✅ NUMBER FORMAT (for counts, qty) */
const format = (v) =>
  v === null || v === undefined ? "-" : v.toLocaleString();

/* ✅ K / L / Cr FORMATTER */
const formatToCappedUnit = (value) => {
  if (value === null || value === undefined) return "-";
  if (value < 1000) {
    return `${value}`;
  }
  if (value < 100000) {
    return `${(value / 1000).toFixed(1)} K`;
  }

  if (value < 10000000) {
    return `${(value / 100000).toFixed(1)} L`;
  }

  return `${(value / 10000000).toFixed(1)} Cr`;
};

const InTransitRecoveryGlobalVisibilityTable = ({ data = [], orderLossType }) => {
  return (
    <div className="tableWrapper">
      <table className="visibilityTable">

        {/* ================= HEADER ================= */}
        <thead>
          <tr className="groupHeader">
            <th colSpan={4}>Shipment View</th>
            <th colSpan={4}>Count Of shipments</th>
            <th colSpan={4}>Value of Shipment</th>
            <th colSpan={4}>Quantity to be unloaded at DC</th>
          </tr>

          <tr className="columnHeader">
            {/* Shipment View */}
            <th>DC</th>
            <th>Average of Ideal Transit time (days)</th>
            <th>Value in Shipment</th>
            <th>{orderLossType} Value Mitigated</th>

            {/* Count */}
            {BUCKETS.map((b) => (
              <th key={`count-${b}`}>{b}</th>
            ))}

            {/* Value */}
            {BUCKETS.map((b) => (
              <th key={`value-${b}`}>{b}</th>
            ))}

            {/* Quantity */}
            {BUCKETS.map((b) => (
              <th key={`qty-${b}`}>{b}</th>
            ))}
          </tr>
        </thead>

        {/* ================= BODY ================= */}
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={16} style={{ textAlign: "center", padding: 16 }}>
                No data available
              </td>
            </tr>
          ) : (
            data.map((row) => {
              const sv = row["Shipment View"];
              const count = row["Count Of shipments"];
              const value = row["Value of Shipment"];
              const qty = row["Quantity to be unloaded at DC"];
              const rowKey = `${sv?.["DC"] || "NA"}-${sv?.["Average of Ideal Transit time (days)"] || "NA"}`;

              return (
                <tr key={`transit-row-${rowKey}`}>
                  {/* ✅ Shipment View */}
                  <td>{sv["DC"]}</td>

                  <td>{format(sv["Average of Ideal Transit time (days)"])}</td>

                  {/* ✅ Value in Shipment */}
                  <td title={sv["Value in Shipment"]}>
                    {formatToCappedUnit(sv["Value in Shipment"])}
                  </td>

                  {/* ✅ Mitigated Value */}
                  <td
                    title={
                      sv[`${orderLossType} Value Mitigated through In Transit`]
                    }
                  >
                    {formatToCappedUnit(
                      sv[`${orderLossType} Value Mitigated through In Transit`]
                    )}
                  </td>

                  {/* ✅ Count Of shipments */}
                  {BUCKETS.map((b) => (
                    <td key={`c-${rowKey}-${b}`}>
                      {format(count[b])}
                    </td>
                  ))}

                  {/* ✅ Value of Shipment (formatted) */}
                  {BUCKETS.map((b) => (
                    <td
                      key={`v-${rowKey}-${b}`}
                      title={value[b]}
                    >
                      {formatToCappedUnit(value[b])}
                    </td>
                  ))}

                  {/* ✅ Quantity */}
                  {BUCKETS.map((b) => (
                    <td key={`q-${rowKey}-${b}`}>
                      {format(qty[b])}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
    </div>
  );
};

InTransitRecoveryGlobalVisibilityTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  orderLossType: PropTypes.string,
};

export default InTransitRecoveryGlobalVisibilityTable;
